"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PropertyFilterRange {
    constructor(fromObject) {
        this.landAcresMin = Math.round(fromObject.landAcresMin);
        this.landAcresMax = Math.round(fromObject.landAcresMax);
        this.salePriceMin = Math.round(fromObject.salePriceMin);
        this.salePriceMax = Math.round(fromObject.salePriceMax);
        this.squareFootageMin = Math.round(fromObject.squareFootageMin);
        this.squareFootageMax = Math.round(fromObject.squareFootageMax);
        this.yearBuiltMin = Math.round(fromObject.yearBuiltMin);
        this.yearBuiltMax = Math.round(fromObject.yearBuiltMax);
    }
}
exports.PropertyFilterRange = PropertyFilterRange;
//# sourceMappingURL=property-filter-range.model.js.map